import DataUtils from '@/utils/DataUtils'
import * as Input from '@/components/base/atoms/input'
import * as CustomInput from '@/components/base/atoms/input/indexCustom'

const compList ={
  VAutocomplete: () => import('vuetify/lib/components/VAutocomplete'),
  VCombobox: () => import('vuetify/lib/components/VCombobox'),
  VRangeSlider: () => import('vuetify/lib/components/VRangeSlider'),
  VSlider: () => import('vuetify/lib/components/VSlider'),
  VSelect: () => import('vuetify/lib/components/VSelect'),
  VTextarea: () => import('vuetify/lib/components/VTextarea'),
  VTextField: () => import('vuetify/lib/components/VTextField'),
  ...Input,
  // add custom Component Here (For Current Project)
  ...CustomInput
}

const basePresetList = {
  default: {
    column: 'col-md-4',
    component: 'VTextField',
  },
  section: {
    column: 'col-12',
    component: 'H2',
  },
  // input
  text: {
    column: 'col-md-4',
    component: 'VTextField',
  },
  textarea: {
    column: 'col-md-4',
    component: 'VTextarea',
  },
  number: {
    column: 'col-md-4',
    component: 'VTextField',
    props: {
      type: 'number'
    }
  },
  checkbox: {
    column: 'col-md-4',
    component: 'AtCheckbox',
  },
  switch: {
    column: 'col-md-4',
    component: 'AtSwitch',
  },
  radio: {
    column: 'col-md-4',
    component: 'AtRadio',
  },
  file: {
    column: 'col-md-4',
    component: 'AtFilePicker',
  },
  date: {
    column: 'col-md-4',
    component: 'AtDatePicker',
  },
  time: {
    column: 'col-md-4',
    component: 'AtTimePicker',
  },
  dateRange: {
    column: 'col-md-4',
    component: 'AtDateRangePicker',
  },
  select: {
    column: 'col-md-4',
    component: 'VSelect',
  },
  autoComplete: {
    column: 'col-md-4',
    component: 'VAutocomplete',
  },
  combobox: {
    column: 'col-md-4',
    component: 'VCombobox',
  },
  rangeSlider: {
    column: 'col-md-4',
    component: 'VRangeSlider',
  },
  slider: {
    column: 'col-md-4',
    component: 'VSlider',
  },
  translations: {
    column: 'col-md-4',
    component: 'AtTranslationTabs',
  }
}
// add preset comps here (For Current Project)
const customPresetList = {

}


const AtFormUtils= {
  compList,
  basePresetList,
  customPresetList,
  genField (key, obj, globalProps) {
    // [type,component,custom]
    // handle `label`
    if (obj.label) {
      obj.props = obj.props ?? {}
      obj.props.label = obj.label
      delete obj.label
    }
    if (obj.component) {
      return obj
    }
    if (obj.custom) {
      return { ...obj, component: obj.custom }
    }

    const type = obj.preset ?? obj.type ?? 'default'

    let targetPreset = basePresetList[type] ?? this.customPresetList[type]

    if (targetPreset === undefined) {
      console.warn(`AtForm Preset Not Found ${type}, use default preset`)
      targetPreset = basePresetList.default
    } else {
      targetPreset.label = key
    }

    const def = DataUtils.mergeObjects(targetPreset, obj)

    // apply global props
    def.props = DataUtils.mergeObjects(def.props, globalProps)
    return def
  }
}

export  {AtFormUtils}